const EXCHANGERS = [
  {
    id: 1,
    caption: 'BYBIT',
    disabled: {},
  },
  {
    id: 2,
    caption: 'BINANCE',
    disabled: {},
  },
  {
    id: 3,
    caption: 'Abcex',
    disabled: {
      paymentMethods: true,
      amount: true,
      timeLimit: true,
      direction: true,
    },
  },
  {
    id: 4,
    caption: 'Rapira',
    disabled: {
      paymentMethods: true,
    },
  },
  {
    id: 5,
    caption: 'Grinex',
    disabled: {
      paymentMethods: true,
    },
  },
];

const MAKER_ROLES = [
  {
    id: 0,
    caption: 'Trader',
  },
  {
    id: 1,
    caption: 'Merchant',
  },
];

const DIRECTIONS = [
  {
    id: 1,
    caption: 'Buy',
  },
  {
    id: 2,
    caption: 'Sell',
  },
];

export default {
  EXCHANGERS,
  MAKER_ROLES,
  DIRECTIONS,
};
